// ModalFormViaje.jsx
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
import { putViaje } from "../helpers/rutaViajes";
import { getEstaciones } from "../helpers/rutaEstaciones"; // si no estaba


import styled from 'styled-components';

const TextoAzul = styled.span`
  color: #2563eb !important;
  font-weight: bold;
  transition: color 0.2s ease;

  &:hover {
    color: #1e40af;
  }
`;

const BotonForm = styled.button.attrs({
  type: 'button', // 👈 esto evita que se dispare el submit del formulario
})`
  background-color: #044a78ff;     /* verde oscuro */
  color: white;
  padding: 0.5rem 1rem;
  width: 120px;
  border: none;
  font-size: 1.2rem; /* 14px = text-sm */
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #06345fff;
  }
`;


const initialState = {
  nroViaje: "",
  fechaInicio: "",
  fechaFin: "",
  tarifaPorKm: 130,
  observaciones: "",
  tramos: [],
  combustible: [],
  viaticos: [],
  adelantos: [],
  gastos: [],
  totalKm: 0,
  totalCombustible: 0,
  totalGastos: 0,
  totalViaticos: 0,
  totalAdelantos: 0,
  liquidacionFinal: 0
};

export default function ModalFormViaje({ viaje, handleClose, show }) {
  const [form, setForm] = useState(initialState);
  const [showSuccess, setShowSuccess] = useState(false);

useEffect(() => {
  if (viaje?._id) {
    // 🔄 Formatear fechas de tramos y combustible
    const tramosFormateados = (viaje.tramos || []).map(t => ({
      ...t,
      fecha: t.fecha ? moment(t.fecha).format("YYYY-MM-DD") : ""
    }));

    const combustibleFormateado = (viaje.combustible || []).map(c => ({
      ...c,
      fecha: c.fecha ? moment(c.fecha).format("YYYY-MM-DD") : ""
    }));

    // 🔄 Setear el formulario
    setForm({
      ...initialState,
      ...viaje,
      fechaInicio: viaje.fechaInicio ? moment(viaje.fechaInicio).format("YYYY-MM-DD") : "",
      fechaFin: viaje.fechaFin ? moment(viaje.fechaFin).format("YYYY-MM-DD") : "",
      tramos: tramosFormateados,
      combustible: combustibleFormateado
    });
  }
}, [viaje]);

const [estaciones, setEstaciones] = useState([]);

useEffect(() => {
  getEstaciones().then((resp) => {
    if (resp.ok && Array.isArray(resp.estaciones)) {
      setEstaciones(resp.estaciones);
    }
  });
}, [])


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({
      ...f,
      [name]: name.includes("total") || name === "tarifaPorKm"
        ? parseFloat(value)
        : value
    }));
  };

  const handleArrayChange = (arrayKey, i, field, value) => {
    const updated = [...form[arrayKey]];
    // updated[i][field] = value;
     // Si el campo es numérico y la caja no está vacía, lo convierto
     if (['litros', 'monto', 'kmTablero'].includes(field)) {
       updated[i][field] = value === '' ? '' : Number(value);
     } else {
       updated[i][field] = value;
     }
    setForm((f) => ({ ...f, [arrayKey]: updated }));
  };

  const addItem = (arrayKey, emptyItem) => {
    setForm((f) => ({ ...f, [arrayKey]: [...f[arrayKey], emptyItem] }));
  };

  const removeItem = (arrayKey, index) => {
    const updated = form[arrayKey].filter((_, i) => i !== index);
    setForm((f) => ({ ...f, [arrayKey]: updated }));
  };


  const METODOS_PAGO_VALIDOS = [
    'Efectivo',
    'YPF Ruta',
    'Transferencia',
    'Cta. Cte.',
    'Sin Pago',
  ];

// ⚙️ Solo fecha y kmTablero son obligatorios; el resto se agrega
// únicamente si tiene algún valor.
const isValidObjectId   = v => typeof v === 'string' && v.length === 24;
const isValidMetodoPago = v => METODOS_PAGO_VALIDOS.includes(v);

const sanitizeCombustible = arr =>
  arr
    .filter(c => c.fecha && c.kmTablero !== '')
    .map(c => {
      const obj = {
        fecha:      new Date(c.fecha),
        kmTablero:  Number(c.kmTablero),
      };

      if (c.litros !== '' && !isNaN(c.litros)) obj.litros = Number(c.litros);
      if (c.monto  !== '' && !isNaN(c.monto))  obj.monto  = Number(c.monto);

      if (c.localidad) obj.localidad = c.localidad;

      // ✅ solo si la opción está en la whitelist
      if (isValidMetodoPago(c.metodoPago)) obj.metodoPago = c.metodoPago;

      // ✅ solo si realmente es un ObjectId
      if (isValidObjectId(c.estacion))     obj.estacion   = c.estacion;

      return obj;
    });


const calcularResumen = () => {
  const totalLitros = form.combustible.reduce((sum, c) => sum + Number(c.litros), 0);
  const kmTableros = form.combustible.map(c => Number(c.kmTablero)).filter(km => !isNaN(km));

  const totalKm = kmTableros.length >= 2
    ? Math.max(...kmTableros) - Math.min(...kmTableros)
    : 0;

  const totalCombustible = form.combustible.reduce((sum, c) => sum + Number(c.monto), 0);
  const totalViaticos = form.viaticos.reduce((sum, v) => sum + Number(v.monto), 0);
  const totalAdelantos = form.adelantos.reduce((sum, a) => sum + Number(a.monto), 0);
  const totalGastos = form.gastos.reduce((sum, g) => sum + Number(g.monto), 0);
  const promedioConsumo = totalLitros ? (totalKm / totalLitros).toFixed(2) : "-";
  // const a = totalAdelantos - totalGastos;
  const liquidacionFinal1 = (totalKm * form.tarifaPorKm) + totalViaticos;
  const liquidacionFinal2 =  totalAdelantos - totalGastos;
  const liquidacionFinal = liquidacionFinal1 - liquidacionFinal2;
  return {
    totalKm,
    totalLitros,
    totalCombustible,
    totalViaticos,
    totalAdelantos,
    totalGastos,
    promedioConsumo,
    liquidacionFinal
  };
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    // const payload = {
    //   ...form,
    //   fechaInicio: form.fechaInicio ? new Date(form.fechaInicio) : null,
    //   fechaFin: form.fechaFin ? new Date(form.fechaFin) : null
    // };
        const payload = {
        ...form,
        fechaInicio: form.fechaInicio ? new Date(form.fechaInicio) : null,
        fechaFin:    form.fechaFin    ? new Date(form.fechaFin)    : null,
    
        // ✅ Combustible con solo los campos obligatorios (+ opcionales si existen)
        combustible: sanitizeCombustible(form.combustible),
     };

    try {
      const resp = await putViaje(viaje._id, payload);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 2000);
    } catch (error) {
      console.error("❌ Error al modificar viaje:", error);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccess(false);
    handleClose();
  };

  const resumen = calcularResumen();

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg">
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontWeight: "bold" }}>
              Editar Viaje Nro. {form.nroViaje}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-row">
              <div className="form-group col-md-2">
                <label>Nro de Viaje</label>
                <input type="text" name="nroViaje" className="form-control" value={form.nroViaje} disabled />
              </div>
              <div className="form-group col-md-3">
                <label>Chofer</label>
                <input
                  type="text"
                  name="chofer"
                  className="form-control"
                  value={form.choferId?.nombre || form.choferId || "-"}
                  disabled
                />
              </div>
              <div className="form-group col-md-4">
                <label>Camión</label>
                <input
                  type="text"
                  name="camion"
                  className="form-control"
                  value={
                    form.camionId && typeof form.camionId === "object"
                      ? `${form.camionId.camion || ""} (${form.camionId.patente || ""})`
                      : "-"
                  }
                  disabled
                />
              </div>
              <div className="form-group col-md-2">
                <label>Tarifa por KM</label>
                <input
                  type="number"
                  name="tarifaPorKm"
                  className="form-control"
                   style={{ color: 'red'}}
                  value={form.tarifaPorKm}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h2 className="font-bold mt-2" style={{ color: 'blue' , fontSize: '1.5rem' }}>Tramos</h2>
            {form.tramos.map((t, i) => (
              <div className="form-row" key={i}>
                <div className="form-group col-md-2">
                  <label>Fecha</label>
                  <input className="form-control" type="date" style={{ width: '12rem'}} value={t.fecha} onChange={(e) => handleArrayChange("tramos", i, "fecha", e.target.value)} />
                </div>
                {["origen", "destino", "remito"].map((field) => (
                  <div key={field} className="form-group col-md-3" style={{ width: '20rem'}}>
                    <label>{field}</label>
                    <input className="form-control" value={t[field]} onChange={(e) => handleArrayChange("tramos", i, field, e.target.value)} />
                  </div>
                ))}
                {/* <div className="form-group col-md-2">
                  <label>KM Inicial</label>
                  <input className="form-control" type="number" style={{ width: '10rem'}} value={t.kmInicial} onChange={(e) => handleArrayChange("tramos", i, "kmInicial", e.target.value)} />
                </div> */}
                {/* <div className="form-group col-md-2">
                  <label>KM Final</label>
                  <input className="form-control" type="number" style={{ width: '10rem'}} value={t.kmFinal} onChange={(e) => handleArrayChange("tramos", i, "kmFinal", e.target.value)} />
                </div> */}
                <div className="form-group col-md-1 d-flex align-items-end">
                  <Button variant="danger" size="sm" style={{ padding: "0.8rem 0.8rem", fontSize: "1.5rem", lineHeight: "1" }} onClick={() => removeItem("tramos", i)}>🗑</Button>
                   
                </div>
              </div>
            ))}
            <BotonForm variant="success" size="sm" onClick={() => addItem("tramos", { fecha: "", origen: "", destino: "", remito: "", kmInicial: 0, kmFinal: 0 })}>+ Tramo</BotonForm>

            <h2 className="font-bold mt-4" style={{ color: 'blue' , fontSize: '1.5rem' }}>Cargas de Combustible</h2>
            {form.combustible.map((c, i) => (
              <div className="form-row" key={i}>
                <div className="form-group col-md-2">
                  <label>Fecha</label>
                  <input className="form-control" style={{ fontSize: '1rem' }} type="date" value={c.fecha || ""} onChange={(e) => handleArrayChange("combustible", i, "fecha", e.target.value)} />
                </div>
                <div className="form-group col-md-1">
                  <label>Litros</label>
                  {/* <input className="form-control" style={{ fontSize: '1rem' }} value={c.litros || ""} onChange={(e) => handleArrayChange("combustible", i, "litros", e.target.value)} /> */}
                  {/* Litros */}
                  <input
                    className="form-control"
                    style={{ fontSize: '1rem' }}
                    type="number"
                    value={c.litros}
                    onChange={e =>
                      handleArrayChange('combustible', i, 'litros', e.target.value)
                    }
                  />
                </div>
                <div className="form-group col-md-1">
                  <label>Monto</label>
                  {/* <input className="form-control" style={{ fontSize: '1rem' }} value={c.monto || ""} onChange={(e) => handleArrayChange("combustible", i, "monto", e.target.value)} /> */}
               {/* Monto */}
                  <input
                    className="form-control"
                    style={{ fontSize: '1rem' }}
                    type="number"
                    value={c.monto}
                    onChange={e =>
                      handleArrayChange('combustible', i, 'monto', e.target.value)
                    }
                  />
                </div>
                <div className="form-group col-md-2">
                  <label>Pago</label>
                  {/* <select
                    className="form-control"
                    style={{ fontSize: '1rem' }}
                    value={c.metodoPago || ''}
                    onChange={(e) => handleArrayChange("combustible", i, "metodoPago", e.target.value)}
                  >
                    <option value="">Seleccionar</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="YPF Ruta">YPF Ruta</option>
                    <option value="Transferencia">Transferencia</option>
                    <option value="Cta. Cte.">Cta. Cte.</option>
                  </select> */}
                  <select
                    className="form-control"
                    style={{ fontSize: '1rem' }}
                    value={c.metodoPago || ''}
                    onChange={e => handleArrayChange('combustible', i, 'metodoPago', e.target.value)}
                  >
                    <option value="">Seleccionar</option>
                    {METODOS_PAGO_VALIDOS.map(m => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group col-md-2">
                  <label>Estación</label>
                  {/* <select
                    className="form-control"
                    style={{ fontSize: '1rem' }}
                    value={typeof c.estacion === 'object' ? c.estacion._id : c.estacion}
                    onChange={(e) => handleArrayChange("combustible", i, "estacion", e.target.value)}
                  >
                    <option value="">Seleccionar Estación</option>
                    {estaciones.map((est) => (
                      <option key={est._id} value={est._id}>
                        {est.estacion}
                      </option>
                    ))}
                  </select> */}
                  <select
                    className="form-control"
                    style={{ fontSize: '1rem' }}
                    value={
                      typeof c.estacion === 'object'
                        ? c.estacion._id
                        : c.estacion ?? ''
                    }
                    onChange={e =>
                      handleArrayChange('combustible', i, 'estacion', e.target.value)
                    }
                  >
                    <option value="">Seleccionar Estación</option>
                    {estaciones.map(est => (
                      <option key={est._id} value={est._id}>
                        {est.estacion}
                      </option>
                    ))}
                  </select>


                </div>

                <div className="form-group col-md-1">
                  <label>Local</label>
                  <input className="form-control" style={{ fontSize: '1rem' }} value={c.localidad || ""} onChange={(e) => handleArrayChange("combustible", i, "localidad", e.target.value)} />
                </div>
                <div className="form-group col-md-2">
                  <label>km Tab</label>
                  {/* <input className="form-control" style={{ fontSize: '1rem' }} value={c.kmTablero || ""} onChange={(e) => handleArrayChange("combustible", i, "kmTablero", e.target.value)} /> */}
                  {/* km Tablero (opcional) */}
                  <input
                    className="form-control"
                    style={{ fontSize: '1rem' }}
                    type="number"
                    value={c.kmTablero}
                    onChange={e =>
                      handleArrayChange('combustible', i, 'kmTablero', e.target.value)
                    }
                  />
        
                </div>
                <div className="form-group col-md-1 d-flex align-items-end">
                  <Button variant="danger" size="sm" style={{ padding: "0.8rem 0.8rem", fontSize: "1.5rem", lineHeight: "1" }} onClick={() => removeItem("combustible", i)}>
                    🗑
                  </Button>
                </div>
              </div>

              // <div className="form-row" key={i}>
              //   {["fecha", "litros", "monto", "metodoPago", "estacion", "localidad", "kmTablero"].map((field) => (
              //     <div key={field} className="form-group col-md-2">
              //       <label>{field}</label>
              //       <input className="form-control" value={c[field] || ""} onChange={(e) => handleArrayChange("combustible", i, field, e.target.value)} />
              //     </div>
              //   ))}
              //   <div className="form-group col-md-1 d-flex align-items-end">
              //     <Button variant="danger" size="sm" style={{ padding: "0.8rem 0.8rem", fontSize: "1.5rem", lineHeight: "1" }} onClick={() => removeItem("combustible", i)}>🗑</Button>
              //   </div>
              // </div>
            ))}
            <BotonForm variant="success" size="sm" onClick={() => addItem("combustible", { fecha: "", litros: "", monto: "", metodoPago: "", estacion: "", localidad: "", kmTablero: "" })}>+ Carga</BotonForm>

            {["viaticos", "adelantos", "gastos"].map((arrayKey) => (
              <div key={arrayKey}>
                <h5 className="mt-4" style={{ color: 'blue' , fontSize: '1.5rem' }}>{arrayKey.charAt(0).toUpperCase() + arrayKey.slice(1)}</h5>
                  {form[arrayKey].map((item, i) => (
                  <div className="form-row" key={i}>
                    <div className="form-group col-md-8">
                      <label>Descripción</label>
                      <input className="form-control" value={item.descripcion} onChange={(e) => handleArrayChange(arrayKey, i, "descripcion", e.target.value)} />
                    </div>
                    <div className="form-group col-md-3">
                      <label>Monto</label>
                      <input className="form-control" type="number" value={item.monto} onChange={(e) => handleArrayChange(arrayKey, i, "monto", e.target.value)} />
                    </div>
                    <div className="form-group col-md-1 d-flex align-items-end">
                      <Button variant="danger" size="sm" style={{ padding: "0.8rem 0.8rem", fontSize: "1.5rem", lineHeight: "1" }} onClick={() => removeItem(arrayKey, i)}>🗑</Button>
                    </div>
                  </div>
                ))}
                <BotonForm variant="success" size="sm" onClick={() => addItem(arrayKey, { descripcion: "", monto: 0 })}>+ {arrayKey.slice(0, -1)}</BotonForm>
              </div>
            ))}

            {/* <h5 className="mt-4">Observaciones</h5>
            <textarea className="form-control" rows="2" name="observaciones" value={form.observaciones} onChange={handleChange}></textarea> */}

            <div className="mt-4 border-top pt-3">
              <h4 className="" style={{ color: 'blue'}}>Resumen</h4>
              <h5>Total KM: {resumen.totalKm}</h5>
              <h5>Valor KM: ${form.tarifaPorKm}</h5>
              <h5>Valor del Viaje: {(resumen.totalKm * form.tarifaPorKm).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</h5>
              <h5>Total Combustible: {resumen.totalCombustible.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</h5>
              <h5>Litros Cargados: {resumen.totalLitros} L</h5>
              <h5>Promedio Consumo: {resumen.promedioConsumo} km/L</h5>
              <h5>Viáticos: {resumen.totalViaticos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })} | Adelantos: {resumen.totalAdelantos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })} | Gastos: {resumen.totalGastos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</h5>
              <h5 className="font-weight-bold">Total a Cobrar: {resumen.liquidacionFinal.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</h5>
            </div>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
            <Button type="submit" variant="dark">Guardar</Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal show={showSuccess} centered backdrop="static" keyboard={false} dialogClassName="animate__animated animate__fadeInDown">
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
}
